module.exports = __webpack_public_path__ + "img/Screenshot_2020-08-17_at_15073@2x 2.2efcbf9d.png";